var map = {
	"./krathong_1.png": "0b7a",
	"./krathong_10.png": "747e",
	"./krathong_2.png": "3ae1",
	"./krathong_3.png": "f3a9",
	"./krathong_4.png": "c04b",
	"./krathong_5.png": "8a2a",
	"./krathong_6.png": "4eae",
	"./krathong_7.png": "f299",
	"./krathong_8.png": "ac31",
	"./krathong_9.png": "4838"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d03";